import Vue from "vue"
import {Toast} from "vant";
export default {
    data() {
        return {

        }
    },
    created: function () {

    },
    mounted: function () {

    },
    methods: {
        fetchData: (url, queryData, callback) => {
            Vue.axios
                .get(url, {params:queryData})
                .then(response => {
                    callback(response)
                })
                .catch(err => {
                    Toast.clear()
                })
        },
        fetchDataPost: function (url ,post ,callback) {
            Vue.axios
                .post(url, post)
                .then(response => {
                    callback(response)
                })
                .catch(err => {
                    Toast.clear()

                })
        },
        uploadFile(url, file) {
          return new Promise((resolve, reject) => {
            let formdata = new FormData()
            formdata.append("file", file);
            Vue.axios
              .post(url, formdata)
              .then(response => {
                resolve(response)
              })
              .catch(err => {
                reject(err)
              })
          })
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/do_request.js